export const layoutSettingsOptions = {
  940: {
    wheelContainerWidth: '60%',
    contentContainerWidth: '40%',
    paddings: 60,
    sidePaddings: 40,
    spinAndContentSpacing: 60,
    noBorderRadius: false
  },
  700: {
    wheelContainerWidth: '50%',
    contentContainerWidth: '50%',
    paddings: 60,
    sidePaddings: 40,
    spinAndContentSpacing: 40,
    noBorderRadius: false
  },
  560: {
    wheelContainerWidth: '100%',
    contentContainerWidth: '100%',
    paddings: 60,
    sidePaddings: 40,
    spinAndContentSpacing: 40,
    noBorderRadius: false
  },
  431: {
    wheelContainerWidth: '100%',
    contentContainerWidth: '100%',
    paddings: 48,
    sidePaddings: 0,
    spinAndContentSpacing: 40,
    noBorderRadius: true
  },
  376: {
    wheelContainerWidth: '100%',
    contentContainerWidth: '100%',
    paddings: 32,
    spinAndContentSpacing: 32,
    sidePaddings: 0,
    noBorderRadius: true
  },
  0: {
    wheelContainerWidth: '100%',
    contentContainerWidth: '100%',
    paddings: 20,
    spinAndContentSpacing: 24,
    sidePaddings: 0,
    noBorderRadius: true
  }
  // 320: {
  //   wheelContainerWidth: '100%',
  //   contentContainerWidth: '100%',
  //   wheelContainerHeight: 286,
  //   wheelSize: 480,
  //
  //   paddings: 20
  // }
};
